import { render, staticRenderFns } from "./OtherExpense.vue?vue&type=template&id=22f56c6a&scoped=true"
import script from "./OtherExpense.vue?vue&type=script&lang=js"
export * from "./OtherExpense.vue?vue&type=script&lang=js"
import style0 from "./OtherExpense.vue?vue&type=style&index=0&id=22f56c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f56c6a",
  null
  
)

export default component.exports